import * as L from 'leaflet';
import { a2l, loc_equal } from 'shared/map/lib/utils';
import MarkerHighlight from '../model';
import { createElementObject, createLayerComponent, } from '@react-leaflet/core';
const RingsLayer = L.Layer.extend({
    initialize(loc, color, on_done, options) {
        this.loc = loc;
        this.color = color;
        this.on_done = on_done;
        L.Util.setOptions(this, options);
    },
    onAdd() {
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.style.left = 0;
        this.div.style.top = 0;
        this._updatePos();
        this.getPane().appendChild(this.div);
        this._start();
    },
    onRemove() {
        L.DomUtil.remove(this.div);
        this.div = null;
    },
    setLoc(loc) {
        this.loc = loc;
        return this._updatePos();
    },
    setColor(color) {
        this.color = color;
    },
    _updatePos() {
        L.DomUtil.setPosition(this.div, this._map.latLngToLayerPoint(this.loc));
        this._start();
    },
    _start() {
        MarkerHighlight({ x: 0, y: 0 }, this.div, this.color, this.on_done);
    },
});
function createHighlightRings(props, context) {
    return createElementObject(
    // @ts-ignore
    new RingsLayer(props.loc, props.color, () => props.onDone(props.device_id)), context);
}
function updateHighlightRings(instance, props, prevProps) {
    if (!loc_equal(prevProps.loc, props.loc)) {
        instance.setLoc(a2l(props.loc));
    }
    if (prevProps.color !== props.color) {
        instance.setColor(props.color);
    }
}
export const HighlightRings = createLayerComponent(createHighlightRings, updateHighlightRings);
